const STUN_SERVER = 'stun:stun.l.google.com:19302';
const ICE_POLL_INTERVAL_MS = 500;
const ICE_MAX_RETRIES = 10;
const DEFAULT_IP = 'unknown';
const LAST_IP_STORAGE_KEY = 'skorozvon_last_ip';

class IpLookup {
  async getIP(): Promise<string> {
    const collected = await this.collect();

    if (collected) {
      this.saveLastIP(collected);
      return collected;
    }

    return this.loadLastIP() ?? DEFAULT_IP;
  }

  private collect(): Promise<string> {
    const PeerConnection =
      window.RTCPeerConnection ||
      (window as unknown as Record<string, typeof RTCPeerConnection>).webkitRTCPeerConnection ||
      (window as unknown as Record<string, typeof RTCPeerConnection>).mozRTCPeerConnection;

    if (!PeerConnection) {
      return Promise.resolve('');
    }

    return new Promise<string>(resolve => {
      try {
        const pc = new PeerConnection({ iceServers: [{ urls: STUN_SERVER }] });
        const candidates: string[] = [];
        let completed = false;
        let retries = ICE_MAX_RETRIES;

        const finish = () => {
          if (completed) return;
          completed = true;
          clearInterval(interval);
          pc.close();
          resolve(candidates.join(','));
        };

        const interval = setInterval(() => {
          if (pc.iceGatheringState === 'complete' || retries <= 0) {
            finish();
            return;
          }
          if (pc.connectionState === 'new' && pc.signalingState === 'have-local-offer') {
            retries--;
          }
        }, ICE_POLL_INTERVAL_MS);

        pc.onicecandidate = (e: RTCPeerConnectionIceEvent) => {
          if (completed || !e.candidate) return;

          const parts = e.candidate.candidate.split(' ');
          const ip = parts[4];

          if (ip && !candidates.includes(ip)) {
            candidates.push(ip);
            if (e.candidate.candidate.includes('typ srflx')) {
              finish();
            }
          }
        };

        pc.createOffer({ offerToReceiveAudio: true })
          .then(offer => pc.setLocalDescription(offer))
          .catch(() => finish());
      } catch {
        resolve('');
      }
    });
  }

  private saveLastIP(ip: string) {
    try {
      window.localStorage.setItem(LAST_IP_STORAGE_KEY, ip);
    } catch {
      return;
    }
  }

  private loadLastIP(): string | null {
    try {
      return window.localStorage.getItem(LAST_IP_STORAGE_KEY);
    } catch {
      return null;
    }
  }
}

const ipLookup = new IpLookup();

export { ipLookup, DEFAULT_IP };
